import {
  LeaderboardEntry,
  ParsedFetchLeaderboardResponse,
} from "../types/leaderboard";

const leaderboardParser: any = {};

leaderboardParser.fetchLeaderboard = (
  response: any
): ParsedFetchLeaderboardResponse => {
  let data: LeaderboardEntry[] = [];


  if (response?.data?.length > 0) {
    data = response?.data?.map((award: any) => ({
      awardId: award.awardId,
      awardName: award.awardName,
      centers: award.centers.map((center: any) => ({
        centerId: center.centerId,
        centerName: center.centerName,
        rank: center.rank,
      })),
    }));
  }

  return {
    leaderboard: data,
    totalAwards: data.length,
  };
};

leaderboardParser.fetchLeaderboardbyid = (response: any): any => {
  let data: LeaderboardEntry[] = [];

  if (response?.data?.length > 0) {
    data = response?.data?.map((entry: any) => ({
      centerId: entry?.centerId,
      centerName: entry?.centerName,
      region: entry?.region,
      funderName: entry?.funderName,
      totalSumScore: parseFloat(entry?.totalScore) || 0,
      totalSumScoreAchieved: parseFloat(entry?.totalScoreAchieved) || 0,
      rank: parseInt(entry?.rank, 10) || 0,
      parameters:
        entry?.parameters?.map((param: any) => ({
          sumScore: parseFloat(param?.sumScore) || 0,
          sumScoreAchieved: parseFloat(param?.sumScoreAchieved) || 0,
          parameterTypeName: param?.parameterTypeName || "",
          parameterTypeId: param?.parameterTypeId || "",
          parameterDetails:
            param.parameters?.map((detail: any) => ({
              score: parseFloat(detail?.score) || 0,
              scoreAchieved: parseFloat(detail?.scoreAchieved) || 0,
              parameterName: detail?.parameterName || "",
            })) || [],
        })) || [],
    }));

    const maxLength0 = Math.max(
      ...(data?.flatMap((entry: any) =>
        entry?.parameters
          .filter((param: any, idx: number) => idx === 0) // Filter for only the 0th index
          .flatMap((param: any) => param?.parameterDetails?.length)
      ) || [])
    );

    const maxLength1 =
      Math.max(
        ...data?.flatMap((entry: any) =>
          entry?.parameters
            .filter((param: any, idx: number) => idx === 1) // Filter for only the 1st index
            .flatMap((param: any) => param?.parameterDetails?.length)
        )
      ) || 0;

    // Normalize parameterDetails arrays
    data?.forEach((entry: any) => {
      entry?.parameters?.forEach((param: any, index: number) => {
        const { parameterDetails } = param;

        // Handle the 0th index specially: check if the 0th parameterName is empty
        if (index === 0) {
          // Handle if 0th index parameterDetails length doesn't match maxLength0
          if (parameterDetails?.length < maxLength0) {
            for (let i = parameterDetails?.length; i < maxLength0; i++) {
              parameterDetails?.push({
                score: 0,
                scoreAchieved: 0,
                parameterName: i === 0 ? "Default 0 Index" : "", // Default name for the 0th index
              });
            }
          }

          // If 0th index is empty, assign a default value to the first element
          if (
            parameterDetails?.length > 0 &&
            parameterDetails[0]?.parameterName === ""
          ) {
            parameterDetails[0].parameterName = "Default 0 Index"; // Assign default name for the 0th index
          }
        }

        // Handle the 1st index or other indices
        if (index === 1) {
          // Handle if 1st index parameterDetails length doesn't match maxLength1
          if (parameterDetails?.length < maxLength1) {
            for (let i = parameterDetails.length; i < maxLength1; i++) {
              parameterDetails?.push({
                score: 0,
                scoreAchieved: 0,
                parameterName: i === 0 ? "Default 1st Index" : "", // Default name for the 1st index
              });
            }
          }
        }
      });
    });
  }

  return {
    leaderboard: data,
    totalEntries: data.length,
  };
};

export default leaderboardParser;
